// @vendors
const { createActions } = require('redux-actions');
//@helpers
const { APIPost } = require('utilities/APIRequestHelper');

const simpleActions = createActions(
    'CONTRACT_ARES_LOAN_STATUS',
    'CONTRACT_ARES_LOAN_HIRING_DOCUMENTS_SUCCESS',
    'CONTRACT_ARES_LOAN_POLICY_SUCCESS',
    'CONTRACT_ARES_LOAN_INE_SUCCESS',
    'CONTRACT_ARES_LOAN_ERROR'
);

const getINELink = (query) => (dispatch) => {
    dispatch(simpleActions.contractAresLoanStatus());

    const params = {
        header: {
            responseType: 'arraybuffer'
        },
        query: {
            ineDocumentPrivateRequest: query.hiringDocumentsPrivateRequest,
            segmentedLoan: query.segmentedLoan,
        }
    };
    return APIPost({ dispatch, endpoint: 'aresINELink', params })
    .then(response => dispatch(simpleActions.contractAresLoanIneSuccess({ response })))
    .catch(response => {
        if (!!response.error) dispatch(simpleActions.contractAresLoanError({ error: response.error }))
        else throw response;
    });
};

const getPolicyLink = (query) => (dispatch) => {
    dispatch(simpleActions.contractAresLoanStatus());

    const params = {
        header: {
            responseType: 'arraybuffer'
        },
        query: {
            policyDocumentPrivateRequest: query.hiringDocumentsPrivateRequest,
            segmentedLoan: query.segmentedLoan,
        }
    };
    return APIPost({ dispatch, endpoint: 'aresContractLink', params })
    .then(response => dispatch(simpleActions.contractAresLoanPolicySuccess({ response })))
    .catch(response => {
        if (!!response.error) dispatch(simpleActions.contractAresLoanError({ error: response.error }))
        else throw response;
    });
};

const getHiringDocuments = (query, allDocuments = false) => (dispatch) => {
    dispatch(simpleActions.contractAresLoanStatus());

    const params = {
        header: {
            responseType: 'arraybuffer'
        },
        query
    };
    if (allDocuments) {
        return APIPost({ dispatch, endpoint: 'aresHiringDocuments', params })
        .then(response => dispatch(simpleActions.contractAresLoanHiringDocumentsSuccess({ response })))
        .then(() => dispatch(getINELink(query)))
        .then(() => dispatch(getPolicyLink(query)))
        .catch(response => {
            if (!!response.error) dispatch(simpleActions.contractAresLoanError({ error: response.error }))
            else throw response;
        });
    }

    dispatch(getINELink(query));
    dispatch(getPolicyLink(query));
};

const sendAresPreContractualMail = query => (dispatch) => {
    const params = { query };
    return APIPost({ dispatch, endpoint: 'aresPrecontractualMail', params });
};

module.exports = {
    simpleActions,
    getHiringDocuments,
    sendAresPreContractualMail,
};